import { Court } from 'modules/jogador/booking/types';

interface CourtSlotSectionProps {
  court: Court;
  selectedTime: string | null;
  onSelect: (court: Court, time: string) => void;
}

export function CourtSlotSection({ court, selectedTime, onSelect }: CourtSlotSectionProps) {
  return (
    <div className="border-b border-border/70 py-4 last:border-b-0">
      <div className="flex items-center justify-between text-sm">
        <span className="font-medium text-ink">{court.name}</span>
        <span className="text-ink-secondary">R$ {court.pricePerHour}/h</span>
      </div>

      <div className="mt-3 grid grid-cols-4 gap-2">
        {court.slots.map((slot) => {
          const isSelected = selectedTime === slot.time;
          const isAvailable = slot.status === 'available';

          return (
            <button
              key={slot.time}
              type="button"
              disabled={!isAvailable}
              onClick={() => onSelect(court, slot.time)}
              className={`rounded-lg border px-2 py-2 text-sm font-medium transition-colors ${
                isSelected
                  ? 'border-primary bg-primary text-surface'
                  : isAvailable
                    ? 'border-border text-ink hover:border-primary'
                    : slot.status === 'fixed'
                      ? 'border-primary/20 bg-primary text-surface opacity-40'
                      : 'border-border bg-chip text-ink-secondary/50'
              }`}
            >
              {slot.time}
            </button>
          );
        })}
      </div>
    </div>
  );
}
